module.exports = __webpack_public_path__ + "media/images/covers/foundation/University-of-Bath-logo-0d48958376431dbe341b6655571a2c6e.svg";